package org.zq.astrock_ai.util

expect fun currentTimeMillis(): Long

/**
 * 东八区（上海）本地时间，精确到秒：yyyy-MM-dd HH:mm:ss
 * 用于顶部「会员至」等展示；不依赖各平台时区 API。
 */
fun formatShanghaiDateTime(epochMs: Long): String {
    if (epochMs <= 0L) return ""
    val zoned = epochMs + 8L * 3_600_000L
    var day = zoned / 86_400_000L
    var tod = zoned % 86_400_000L
    if (tod < 0L) {
        tod += 86_400_000L
        day -= 1L
    }
    val secTotal = tod / 1000L
    val h = secTotal / 3600L
    val m = (secTotal % 3600L) / 60L
    val s = secTotal % 60L
    // civil_from_days（days since 1970-01-01）
    val z = day + 719_468L
    val era = (if (z >= 0L) z else z - 146_096L) / 146_097L
    val doe = z - era * 146_097L
    val yoe = (doe - doe / 1460L + doe / 36_524L - doe / 146_096L) / 365L
    val y = yoe + era * 400L
    val doy = doe - (365L * yoe + yoe / 4L - yoe / 100L)
    val mp = (5L * doy + 2L) / 153L
    val d = doy - (153L * mp + 2L) / 5L + 1L
    val mth = mp + if (mp < 10L) 3L else -9L
    val year = y + if (mth <= 2L) 1L else 0L
    fun p2(n: Long) = n.toString().padStart(2, '0')
    return "${year.toString().padStart(4, '0')}-${p2(mth)}-${p2(d)} ${p2(h)}:${p2(m)}:${p2(s)}"
}
